/**
 * Porcentaje de una tasa decimal (0.07 → "7", 0.035 → "3,5") para etiquetas.
 *
 * En coma flotante 0.07 * 100 da 7.000000000000001 y 0.035 * 100 da
 * 3.5000000000000004, así que se redondea a 2 decimales antes de formatear
 * (configuración regional española, sin ceros a la derecha).
 */
export function formatearPorcentajeIrpf(tasa: number | undefined | null): string {
  const valor = Number.isFinite(tasa) ? Number(((tasa as number) * 100).toFixed(2)) : 0;
  return valor.toLocaleString('es-ES', { maximumFractionDigits: 2 });
}
